import { useEffect, useReducer } from "react";
import { useOutletContext, useLocation, useNavigate } from "react-router-dom";
import { isAxiosError } from "axios";
import { axiosErrorToStringError } from "@/utils/axiosErrorToStringError";
import { Save } from "lucide-react";
import { useAdminCreateSkill } from "@/services/skillService";



const initialState = {
    apiPayload: {
        name: '',
        code: '',
        active: true,
    },
    error_message: "",
    isLoading: false
}



const ACTIONS = {
    SET_API_PAYLOAD_FIELD: 'setApiPayloadField',
    SET_ERROR_MESSAGE: 'setErrorMessage',
    SET_IS_LOADING: 'setIsLoading',
}



const reducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.SET_API_PAYLOAD_FIELD:
            return { ...state, apiPayload: { ...state.apiPayload, [action.subtype]: action.payload }, error_message: null }
        case ACTIONS.SET_ERROR_MESSAGE:
            return { ...state, error_message: action.payload }
        case ACTIONS.SET_IS_LOADING:
            return { ...state, isLoading: action.payload }
        default:
            throw new Error("Unknown action.type " + action.type);
    }
}

export default function Add() {

    const [ , setPageTitle,  , setShowBackButton] = useOutletContext()
    const [state, dispatch] = useReducer(reducer, initialState)

    const navigate = useNavigate()
    const location = useLocation()

    const adminCreateSkill = useAdminCreateSkill()


    /* On met à jour le titre */
    useEffect(() => {
        setPageTitle("Ajout d'un métier")
        setShowBackButton(true)

        return () => {
            setPageTitle("Titre")
            setShowBackButton(false)
        }
    }, [setPageTitle, setShowBackButton])



    /* Gestion des changements de champs du formulaire */
    const handleChange = (e) => {
        dispatch({ type: ACTIONS.SET_ERROR_MESSAGE, payload: null });
        dispatch({ type: ACTIONS.SET_API_PAYLOAD_FIELD, subtype: e.target.name, payload: e.target.type == 'checkbox' ? e.target.checked : e.target.value })
    }



    /* Soumission du formulaire */
    const handleSubmit = async (e) => {
        e.preventDefault()

        if(!state.apiPayload.name || !state.apiPayload.code ) {
            dispatch({ type: ACTIONS.SET_ERROR_MESSAGE, payload: "Veuillez remplir tous les champs obligatoires" });
            return 
        }

        const payload = {
            ...state.apiPayload
        }

        dispatch({ type: ACTIONS.SET_IS_LOADING, payload: true });

        try {
            await adminCreateSkill(payload)
            navigate(location.state?.from ?? "/admin/skills")
        } catch (error) {
            console.error('admin/skills/add::handleSubmit::error', error)
            if (error?.response?.status === 412) {
                dispatch({ type: ACTIONS.SET_ERROR_MESSAGE, payload: "Erreur de validation en base de données (code déjà utilisé, contrainte non respectée)" });
            } else if (isAxiosError(error)) {
                dispatch({ type: ACTIONS.SET_ERROR_MESSAGE, payload: axiosErrorToStringError(error) });
            } else {
                dispatch({ type: ACTIONS.SET_ERROR_MESSAGE, payload: error?.message || "Erreur inconnue" });
            }
        } finally {
            dispatch({ type: ACTIONS.SET_IS_LOADING, payload: false });
        }
    }





    return (
        <>
            <h2 className="text-secondary text-lg flex-none content-center mb-4">
                Paramètres du métier
            </h2>

            <form className="flex flex-col gap-4" onSubmit={(e) => handleSubmit(e)}>

                {/* Premiere ligne : code*/}
                <div className="md:w-[30%] flex flex-row flex-wrap gap-5 content-stretch">
                    <div className="flex flex-col gap-2 flex-auto">
                        <label className="text-primary text-base" htmlFor="code">
                            Code <span className="text-red-500">*</span>
                        </label>
                        <input type="text" className="w-full border border-secondary rounded-md"
                            id="code" name="code" 
                            value={state.apiPayload.code} 
                            onChange={handleChange}
                            required
                            />
                    </div>
                </div>
                {/* Deuxieme ligne : nom */}
                <div className="md:w-[70%] flex flex-row flex-wrap gap-5 content-stretch">
                    <div className="flex flex-col gap-2 flex-auto">
                        <label className="text-primary text-base" htmlFor="name">
                            Nom <span className="text-red-500">*</span>
                        </label>
                        <input type="text" className="w-full border border-secondary rounded-md"
                            id="name" name="name" 
                            value={state.apiPayload.name} 
                            onChange={handleChange}
                            required
                            />
                    </div>
                </div>

                {/* Troisieme ligne : active */}
                <div className="md:w-[30%] flex flex-row flex-wrap gap-5">
                    <div className="flex flex-row gap-2 flex-auto items-center">
                       
                        <input type="checkbox" className="border border-secondary rounded-md h-6 w-6"
                            id="active" name="active" 
                            checked={state.apiPayload.active} 
                            onChange={handleChange}
                        />
                         <label className="text-primary text-base" htmlFor="active">
                            Actif
                        </label>
                    </div>
                </div>

                
                <div className="w-[50%] gap-5 flex flex-row items-center">
                    
                    <button className="flex gap-2 items-center border border-blue-500 rounded-md px-2 py-1 text-base hover:bg-blue-200"
                        onClick={(e) => handleSubmit(e)}
                        disabled={state.isLoading}
                    >
                        <Save size={24} className="text-primary" />
                        Sauvegarder
                    </button>
                    
                    {
                        state?.error_message && <span className="text-red-700 flex-none content-center mr-4">{state.error_message}</span>
                    }
                </div>
            </form>
        </>
    )
}